import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterMobileStores = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("@honeycomb/mobile/mobile.css");
    import("@honeycomb/mobile")
      .then((lib) => {
        resolve({
          default: () => <lib.StoresPage />,
        });
      })
      .catch(reject);
  });
});

export const LazyMobileStores = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterMobileStores />
    </Suspense>
  );
};
